import { WarningOutlined } from "@ant-design/icons";
import { DatePicker as AntdDatePicker, ConfigProvider } from "antd";
import cx from "classnames";
import { useField } from "formik";

import styles from "./DatePicker.module.css";
import enUS from "antd/es/locale/en_US";
import thTh from "antd/es/locale/th_TH";
import { useTranslation } from "react-i18next";

import localeTh from 'antd/es/date-picker/locale/th_TH';
import localeEn from 'antd/es/date-picker/locale/en_US';

function DatePicker({
  label = "",
  name = "",
  placeholder = "",
  type = "text",
  size = "middle",
  className = "",
  required = false,
  disabled = false,
  format = "DD/MM/YYYY",
  max = null,
  min = null,
  onChange = () => { },
  disabledDate = () => { },
  defaultValue = null,
  readOnly = false,
}) {
  const [field, meta, helpers] = useField(name);
  const { onBlur } = field;
  const { value, error, touched } = meta;
  const { setValue } = helpers;
  const { t, i18n } = useTranslation();

  const handleChange = (date) => {
    setValue(date);
    onChange(date);
  };

  function localeFn() {
    if (i18n.language === 'en') {
      return localeEn
    } else {
      return {
        ...localeTh,
        lang: {
          ...localeTh.lang,
          yearFormat: "BBBB",
          dateFormat: "D/M/BBBB",
          cellYearFormat: "BBBB"
        }
      }
    }
  }
  const translatedError =
    touched && error
      ? i18n?.language === "th"
        ? `กรุณาเลือก ${label}`
        : `Please enter ${label?.toLowerCase?.()}`
      : "";

  return (

    <div className={cx(styles.container, className)}>
      {label && (
        <label className={cx("label", styles.label)} htmlFor={name}>
          {label}
          {required && <span className="error">*</span>}
        </label>
      )}
      <ConfigProvider locale={i18n.language === 'en' ? enUS : thTh}>
        <AntdDatePicker
          id={name}
          locale={localeFn()}
          className={styles.input}
          name={name}
          placeholder={placeholder}
          type={type}
          readOnly={readOnly}
          value={value || defaultValue}
          onChange={handleChange}
          onBlur={onBlur}
          data-state={touched && error ? "error" : ""}
          status={touched && error ? "error" : ""}
          disabled={disabled}
          data-type={type}
          size={size}
          maxDate={max}
          minDate={min}
          format={i18n.language === 'en' ? format : format?.replace?.(/(Y)/g, "B")}
          disabledDate={disabledDate}
        />
      </ConfigProvider>
      {translatedError && (
        <span className={cx("error", styles.error)}>
          <WarningOutlined /> {translatedError}
        </span>
      )}
    </div>
  );
}

export default DatePicker;
